import { render, staticRenderFns } from "./LayoutNavbar.vue?vue&type=template&id=04fbf87b&"
import script from "./LayoutNavbar.vue?vue&type=script&lang=js&"
export * from "./LayoutNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports